
import { useLanguage } from "@/contexts/language";

export function LoadingSpinner() {
  const { language } = useLanguage();
  
  return (
    <div className="flex flex-col items-center justify-center my-8">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary mb-4"></div>
      <p className="text-muted-foreground text-sm">
        {language === 'ja' 
          ? 'データを読み込み中...' 
          : 'Loading your data...'}
      </p>
    </div>
  );
}
